import React, { useState } from "react";
import ContactForm from "./ContactForm";
import TitleHeader from "../../global/TitleHeader";
import ContactDetails from "./ContactDetails";
import NewsLetter from "../home/NewsLetter";

const ContactIndex = () => {
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <div className="flax-col gap-16">
      <TitleHeader
        title="Contact Us"
        description="Learn more about our mission, vision, and values."
      />
      <div className="px-4 flax-col flax">
        <div className="section-container grid md:grid-cols-2 gap-8 items-start">
          <ContactDetails />
          <ContactForm />
        </div>

        <div className="w-full h-[500px] mt-10 relative">
          {!mapLoaded && (
            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 z-10 rounded-xl">
              <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary-200"></div>
              {/* You can replace this with any loader/spinner component */}
            </div>
          )}

          {/* <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1860.5023853122943!2d72.82979644824489!3d21.152208434082127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be051dfa0342603%3A0x7e68c22969317680!2sKarmayogi%20Society%201%2C%20Pandesara%2C%20Udhana%2C%20Surat%2C%20Gujarat%20394221!5e0!3m2!1sen!2sin!4v1746082449368!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded-xl
            shadow-md"
            title="google map"
            onLoad={() => setMapLoaded(true)}
          ></iframe> */}
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1451.3017303287545!2d72.8428805!3d21.1310975!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be051b63400d3b9%3A0x74112a52a5ef6b65!2sTech%20Park%20Industrial%20Society%2C%203%2C%20Bhestan%2C%20Surat%2C%20Gujarat%20395023!5e1!3m2!1sen!2sin!4v1747039865321!5m2!1sen!2sin" width="100%"   style={{ border: 0 }}
            height="100%"  allowfullscreen="" loading="lazy" title="google map" referrerpolicy="no-referrer-when-downgrade"  onLoad={() => setMapLoaded(true)}></iframe>
        </div>
      </div>
      <NewsLetter />
    </div>
  );
};

export default ContactIndex;
